import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axiosRequest from "./axiosRequest";

// Minimal list so the phone/country selector can render INSTANTLY while the
// full country list loads from the (slow) public/get-country endpoint. Without
// this the input sits behind a loading skeleton for several seconds and looks
// like it's missing. The full list replaces this seamlessly once it arrives.
const PLACEHOLDER_COUNTRIES = [
  { id: 101, flag: "https://flagcdn.com/w40/in.png", name: "India", phonecode: "91", shortname: "IN" },
  { id: 231, flag: "https://flagcdn.com/w40/us.png", name: "United States", phonecode: "1", shortname: "US" },
];

export const useGetCountries = () => {
  return useQuery({
    queryKey: ["get-countries-phone-code"],
    queryFn: async () => {
      const response = await axiosRequest("public/get-country", "GET");

      if (!response.data.status) {
        return { countryData: PLACEHOLDER_COUNTRIES };
      }
      return response.data.data;
    },
    placeholderData: { countryData: PLACEHOLDER_COUNTRIES },
    onError: (error) => {
    },
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 15,
  });
};
